import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '@deliveroo/consumer-component-library/components/Button';

import styles from './styles.scss';

export default function ModalFooter({
  onSubmit,
  modal,
  hidePrevious,
  cta,
  disabled,
  isLoading,
  buttonType,
}) {
  const showPrevious = modal && !hidePrevious;
  const onBack = () => window.history.back();
  if (!showPrevious && !onSubmit) {
    return null;
  }

  const submitText = cta || 'Submit';

  return (
    <div className={classnames({ [styles.modal]: modal })}>
      <div className={styles.footer}>
        {showPrevious && (
          <Button type="secondary" spacing="0 medium 0 0" onClick={onBack}>
            Previous
          </Button>
        )}
        {onSubmit && (
          <Button
            isBlock
            isDisabled={disabled}
            isLoading={isLoading}
            onClick={onSubmit}
            type={buttonType}
          >
            {submitText}
          </Button>
        )}
      </div>
      <div className={styles.footerPlaceholder} />
    </div>
  );
}

ModalFooter.defaultProps = {
  onSubmit: null,
  modal: false,
  hidePrevious: false,
  cta: null,
  disabled: false,
  isLoading: false,
  buttonType: 'primary',
};

ModalFooter.propTypes = {
  onSubmit: PropTypes.func,
  modal: PropTypes.bool,
  hidePrevious: PropTypes.bool,
  cta: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  buttonType: PropTypes.string,
};
